import { PATH } from "../constant";
import { noAuthApiService } from "./api.service";

async function checkStatusVendingInfoByToroGo(body: any,) {
  return await noAuthApiService.post(PATH.VENDING.CHEK_STATUS_VENDING_INFO_TRG, body);
}

async function getVendingInfoByToroGo(body: any,) {
  return await noAuthApiService.post(PATH.VENDING.GET_VENDING_INFO_TRG, body);
}

async function getAdvertiseByToroGo(body: any) {
  return await noAuthApiService.post(PATH.VENDING.GET_ADVERTISE_TRG, body);
}

async function getListVendingByToroGo(body: any) {
  return await noAuthApiService.post(PATH.VENDING.GET_LIST_VENDING_TRG, body);
}

async function updateSyncData(body: any) {
  return await noAuthApiService.post(PATH.VENDING.UPDATE_SYNC_DATA, body);
}

async function getOrderMachineInfo(body: any,) {
  return await noAuthApiService.post(PATH.VENDING.GET_ORDER_MACHINE, body);
}

export const vendingMachineService = {
  checkStatusVendingInfoByToroGo,
  getVendingInfoByToroGo,
  getListVendingByToroGo,
  getAdvertiseByToroGo,
  updateSyncData,
  getOrderMachineInfo
};
